export default __webpack_public_path__ + "static/media/boy-robot.9de91ca8.png";